module.exports = __webpack_public_path__ + "static/media/Botswana.2317f83c.png";